import { IReduxAction } from '../../views/interfaces';
import { GET_REVENUE_BY_YEAR_SUCCESS } from '../actions';

const initialState = {
  data: null  
};

export const revenueByYearReducer = (state = initialState, { type, payload }: IReduxAction) => {
  switch (type) {
    case GET_REVENUE_BY_YEAR_SUCCESS: {
      return { ...state, data: payload };
    }
    default:
      return state;
  }
}; 